import { useState, useEffect } from "react";
import { useToastPromise } from "../../components/toastPromise";
import { NewsController } from "../../controllers/newsController";
import "../../assets/css/news.css";
import { News } from "./news";
import { TableList } from "../../components/tableList";
import { RichTextPreview } from "../../components/richTextPreview";

export const AllNews = ({ user }) => {
  const toastPromise = useToastPromise();
  const [loading, setLoading] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  useEffect(() => {
    getAll();
  }, []);
  const getAll = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        NewsController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const fetchedData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setNewsList(fetchedData);
        return "News details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handleDeleteSelected = (selectedRows, success) => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        NewsController.deleteAll({
          idList: selectedRows,
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: success,
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const handlePopupDialogOpen = (news = null) => {
    setSelectedData(news);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  const handlePreviewPopupDialogOpen = (info = null) => {
    setSelectedData({ info: info });
    setIsPreviewOpen(true);
  };
  const handlePreviewClose = () => {
    setIsPreviewOpen(false);
  };

  return (
    <section id="newsList">
      <h4>NEWS</h4>
      <hr />
      <TableList
        loading={loading}
        list={newsList}
        handlePopupDialogOpen={handlePopupDialogOpen}
        handlePreviewPopupDialogOpen={handlePreviewPopupDialogOpen}
        deletePromise={(selectedRows, success) => {
          handleDeleteSelected(selectedRows, success);
        }}
      />
      <News
        user={user}
        isOpen={isOpen}
        handleClose={handleClose}
        getAll={getAll}
        selectedData={selectedData}
        handlePreviewPopupDialogOpen={handlePreviewPopupDialogOpen}
      />
      <RichTextPreview
        isPreviewOpen={isPreviewOpen}
        handlePreviewClose={handlePreviewClose}
        content={selectedData?.info}
      />
    </section>
  );
};
